import React, {useState} from 'react';
import {buttonStyle, formBlock, inputErrorStyle, inputStyle, labelStyle} from "../../../../../styles/forms";
import {useForm} from "react-hook-form";
import {createAccount} from "../../../../../services/APIService/Accounts";
import {selectAccount, updateUser} from "../../../../../services/Auth";
import {useNavigate} from "react-router-dom";

const CreateAccount = () => {
  const { register, handleSubmit, formState: { errors } } = useForm({});
  const [message, setMessage] = useState("")
  const navigate = useNavigate()

  const onSubmit = (data) => {
    createAccount(data)
      .then((res) => {
        selectAccount(JSON.stringify(res.data.data.account))
        updateUser(res.data.data.user)
        navigate(`/app/projects`)
      })
      .catch(err => {
        setMessage(err.response.message)
      })
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={formBlock}>
          <label className={labelStyle}>Account Name</label>
          <input className={inputStyle} type="text" {...register("name", { required: true, onChange: () => setMessage("") })} />
          {errors.name && <p className={inputErrorStyle}>Name is required and must be valid</p>}
        </div>
        <div className="flex justify-end">
          <button className={buttonStyle} type="submit">
            Create Account
          </button>
          {message && <p className={inputErrorStyle}>{message}</p>}
        </div>
      </form>
    </div>
  )
}

export default CreateAccount